var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"visible":_vm.visible,"top":"15%","width":"40%","title":"开通会员提示","before-close":_vm.handleCancel}},[_c('div',{staticClass:"content"},[_vm._v("您的免费下载权益剩余次数为 0 ，如需继续使用，请开通会员海量正版素材任您挑选。")]),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('div',{staticClass:"buy",on:{"click":_vm.goPackage}},[_vm._v("订阅会员 全站资源任意选")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }